import { useCallback, useEffect } from 'react';
import { RouteLocation } from 'types/common.consts';

const useMapboxRoutePlayer = (
	isPlaying: boolean,
	route: RouteLocation[],
	routeIndex: number,
	onRouteTrackerGotToEndOfRoute: () => void,
	onRouteTrackerPlay: () => void,
	onRouteTrackerStop: () => void
) => {
	useEffect(() => {
		if (!isPlaying) {
			onRouteTrackerStop();
			return;
		}
		playRouteTracker();
	}, [routeIndex, isPlaying]);

	const playRouteTracker = useCallback(() => {
		const lastPoint = route.length - 2;
		if (routeIndex > lastPoint) {
			onRouteTrackerGotToEndOfRoute();
			return;
		}
		onRouteTrackerPlay();
	}, [route, routeIndex]);

	return { playRouteTracker };
};
export default useMapboxRoutePlayer;
